import React, { ReactNode, useEffect } from "react";
import { useKeyPress } from "ahooks";
import { IonIcon } from "@ionic/react";
import { close } from "ionicons/icons";
import { createPortal } from "react-dom";

type LightboxProps = {
  onClose: () => void;
  children: ReactNode;
};

const Lightbox = ({ onClose, children }: LightboxProps) => {
  useKeyPress("esc", onClose);

  useEffect(() => {
    const block = (e: TouchEvent) => e.preventDefault();
    document.addEventListener("touchmove", block, { passive: false });
    return () => document.removeEventListener("touchmove", block);
  }, []);

  return createPortal(
    <div
      onClick={onClose}
      onTouchMove={(e) => e.preventDefault()}
      className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-0 sm:p-6"
      style={{
        paddingTop: "calc(env(safe-area-inset-top))",
        paddingBottom: "calc(env(safe-area-inset-bottom))",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full h-full sm:w-auto sm:h-auto sm:max-w-[90vw] sm:max-h-[90vh] flex items-center justify-center"
      >
        {children}
      </div>
      <button
        type="button"
        aria-label="Close"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        className="absolute right-4 w-10 h-10 rounded-full bg-black/60 text-white text-xl flex items-center justify-center"
        style={{ top: "calc(env(safe-area-inset-top) + 1rem)" }}
      >
        <IonIcon icon={close} className="text-2xl" />
      </button>
    </div>,
    document.body,
  );
};

export default Lightbox;
